import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import AppBar from '@mui/material/AppBar';
import {Box, Typography} from '@mui/material';
import DTH_Logo from 'common/assets/images/DTHLogo.png';
import { UserMenu } from 'common/navigation';
import { RedTheme } from 'common/global';
import NavigationMenuMobile from 'common/navigation/NavigationMenuMobile';
import { useScreen } from 'common/hooks/useScreen';
import { DownloadNotifications } from 'common/components/downloadNotification';

export const Header = ({ logo, showNavigation }) => {
  const [userId, setUserId] = useState('');
  let redtheme = RedTheme;
  const screen = useScreen();
  const delegateObj = JSON.parse(localStorage.getItem('delegateProfileSwitched'));

  let getLoggedInUserDetails = useSelector((state) => state.tapUserDetailsRd);
  useEffect(() => {
    if (getLoggedInUserDetails && Object.keys(getLoggedInUserDetails).length) {
      setUserId(getLoggedInUserDetails?.userDetails?.data[0].user_id);
    }
  }, [getLoggedInUserDetails]);

  return (
    <>
      {/** Sticky header appbar */}
      <AppBar
        className='tap-appbar-header1'
        position='sticky'
        sx={{
          bgcolor: redtheme.palette.box.white,
          ...(screen.isMobile ? { boxShadow: 'none', padding: '8px', bgcolor: 'transparent' } : {}),
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            padding: {
              xs: '0px 10px',
              sm: '0px 10px',
              md: '0px 42px',
              lg: '0px 72px',
              xl: '0px 72px',
            },
            height: '64px',
            background: redtheme.palette.box.white,
            ...(screen.isMobile
              ? { borderRadius: '8px', boxShadow: '0 0 16px 0 rgba(0,0,0,0.25)' }
              : {}),
          }}
        >
          <Box display={'flex'}>
            {/** App Logo */}
            <Box
              sx={{
                position: 'relative',
                width: '50%',
                display: 'flex',
                alignItems: 'flex-start',
              }}
            >
              {logo || (
                <img
                  src={DTH_Logo}
                  className='dth-logo'
                  title='DTH'
                  alt='DTH'
                  height='42px'
                  width='172px'
                />
              )}
            </Box>
            {/** Logged In Profile User */}
            <Box
              sx={{
                flexGrow: 0,
                width: '50%',
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'center',
                gap: '10px',
              }}
            >
              {/* Only show notification bell if user is logged in */}
              {userId && (
                <Box sx={{ color: 'action.active' }}>
                  <DownloadNotifications userId={userId} />
                </Box>
              )}
              <UserMenu></UserMenu>
              {showNavigation && <NavigationMenuMobile />}
            </Box>
          </Box>
          <Box display={'flex'}>
            {delegateObj?.isDelegateSwitch &&
              <Box display={'flex'} justifyContent={'flex-end'} width={'100%'}>
                <Typography fontFamily={'"JohnsonText-Light"'} fontSize={'14px'} color={redtheme.palette.primary.main}>
                  {delegateObj?.message || ''}
                </Typography>
              </Box>
            }
          </Box>
        </Box>
      </AppBar>
    </>
  );
};
